export default __webpack_public_path__ + "static/stone-style-2-41bba093e5929e96bc8935feeb02bae1.png";